<template>
    <DatePick v-bind="$attrs"
              ref="date-pick"
              class="dt-date-pick">
        <!-- Create a slot in this wrapper whose contents actually goes into the
        slot in the child -->
        <template v-slot:default="slotProps">
            <slot v-bind="slotProps"></slot>
        </template>
    </DatePick>
</template>

<script>
import DatePick from './VueDatePick/VueDatePick';

// A date picker that looks the same as in the Back Office.
// Use this component instead of directly using vue-date-pick so that our styles are applied.
export default {
    components: {
        DatePick,
    },

    methods: {
        open() {
            this.$refs['date-pick'].open();
        },
    },
};
</script>

<style lang="less">
@import "../../../less/variables.less";

.dt-date-pick {
    .vdpInnerWrap {
        box-shadow: 0 5px 15px rgba(0, 0, 0, .5);
        border: none;
        padding: 0;
    }

    .vdpOuterWrap.vdpFloating {
        z-index: 1050;
        .vdpInnerWrap {
            width: 350px;
            max-width: none;
        }
    }

    .vdpHeader {
        background: @dark-blue;
        padding: 0 1em 0;
        margin: 0;
    }

    .vdpPeriodControl button {
        color: @white;
    }

    .vdpArrow {
        height: 100%;
        top: 0;
    }

    .vdpArrowPrev:after {
        border-right-color: @white;
    }

    .vdpArrowNext:after {
        border-left-color: @white;
    }

    .vdpCellContent {
        font-weight: normal !important;
    }

    .vdpHeadCell {
        padding: 0;
    }

    .vdpTable {
        width: ~"calc(100% - 32px)";
        margin: 10px 16px 16px;
    }

    .vdpCell {
        padding: 8px 10px;
    }

    .vdpCellContent {
        font-size: 16px;
    }

    .vdpCell.today {
        color: @dt-dark-blue;
    }

    .vdpCell.selectable:hover .vdpCellContent,
    .vdpCell.selected .vdpCellContent {
        background: @dt-dark-blue;
    }
}

</style>
